.jb-options-web-component {
  .option-content-wrapper {
    min-height: 36px;
    display: flex;
    align-items: center;
    font-size: 0.9em;
    color: var(--jb-select-option-color, inherit);
    background-color: var(--background-color);

    &:hover {
      background-color: var(--background-color-hover);
      color: var(--option-color-hover);
      cursor: pointer;
    }
  }
  &.--selected {
    font-weight: 900;
  }
  &.--hidden{
    display: none;
  }
}